import { useEffect } from "react";
import { hasDirtyComponents } from "lib/util/ComponentController";

type GlobalDirtyCheckerProps = {
  disabled?: boolean;
};

export function GlobalDirtyChecker({
  disabled = false,
}: GlobalDirtyCheckerProps) {
  useEffect(() => {
    if (disabled) {
      return;
    }

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (!hasDirtyComponents()) {
        return;
      }

      event.preventDefault();
      event.returnValue = "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [disabled]);

  return null;
}
